import React, { useMemo } from 'react'

import { pluralizeToString } from 'lib/string/pluralize'
import { connect } from 'react-redux'
import { buildSuggestedDatesParamsKey, buildSuggestedDatesString } from 'lib/search/searchUtils'
import { getSuggestedDates } from 'selectors/offerSelectors'
import { prettyDates } from 'components/Search/utils'
import moment from 'moment'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowPrice from 'components/Luxkit/PricePoints/PriceRowPrice'

interface MappedStateProps {
  suggestedDates: App.OfferSuggestedDates;
}
export interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  price: number
  duration: number
  filters: App.OfferListFilters
}

function MapViewBedbankPricing(props: Props & MappedStateProps) {
  const {
    offer,
    price,
    duration,
    suggestedDates,
    filters,
  } = props

  const hasSuggestedCheckInCheckOut = suggestedDates?.checkIn && suggestedDates?.checkOut

  const hasDates = !!filters?.checkIn

  const nightlyPrice = duration ? price / duration : price

  const displayPrice = hasDates ? price : nightlyPrice

  const durationText = useMemo(() => {
    if (hasDates) {
      return prettyDates(moment(filters?.checkIn), moment(filters?.checkOut))
    }
    if (!duration) {
      return 'from'
    }
    if (hasSuggestedCheckInCheckOut) {
      return `${buildSuggestedDatesString(suggestedDates.checkIn, suggestedDates.checkOut)} from`
    }
    return pluralizeToString('night', duration) + ' from'
  }, [duration, filters?.checkIn, filters?.checkOut, hasDates, hasSuggestedCheckInCheckOut, suggestedDates?.checkIn, suggestedDates?.checkOut])

  return <>
    <PriceRowPriceCaption>{durationText}</PriceRowPriceCaption>
    <PriceRowPrice
      size="S"
      price={suggestedDates?.price ?? displayPrice}
      saleUnit={hasDates ? offer.saleUnit : 'night'}
      taxesAndFees={offer.sell?.taxesAndFees ?? 'inclusive'}
    />
  </>
}

export default connect<MappedStateProps, undefined, Props, App.State>((appState, ownProps) => {
  const flexibleSearchFilterKey = buildSuggestedDatesParamsKey(ownProps.filters?.flexibleMonths, ownProps.filters?.flexibleNights, ownProps.filters?.rooms)
  return {
    suggestedDates: getSuggestedDates(appState, flexibleSearchFilterKey, ownProps.offer.id),
  }
})(MapViewBedbankPricing)
